<div class="{{type?'m0 webview box':''}}">
  <div class="container" [formGroup]="subsForm">
    <div class="header">
      <p [ngClass]="getHeaderStyles()">
        Current Package
      </p>
    </div>
    <div class="cir-border">
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group">
        <mat-radio-button disableRipple="true" [disabled]="'disabled'" checked="checked">
          <app-gdo-subscription-item [subscription]="currentSelectedPackage"></app-gdo-subscription-item>
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="header">
      <p [ngClass]="getHeaderStyles()">
        Available Package
      </p>
    </div>
    <div class="" formGroupName="packageDetails">
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
        formControlName="availablePackageSelection">
        <div (click)="controlChange(i)" class="margin-b-1"
          [ngClass]="{
            'cir-selected':setborder == i && type,
            'cir-selected-red':setborder == i && !type,
            'cir-border': setborder !=i
            }"

          *ngFor="let subscription of selectedPlans; index as i; trackBy: trackBySubscriptionPlan" role="button" tabindex="0" aria-label="Select option" (keydown.enter)="controlChange(i)" (keydown.space)="$event.preventDefault(); controlChange(i)">
          <mat-radio-button disableRipple="true" [value]="subscription" [checked]="subscription.isSelected">
            <app-gdo-subscription-item [subscription]="subscription"></app-gdo-subscription-item>
          </mat-radio-button>
        </div>
      </mat-radio-group>
      <!-- <mat-checkbox *ngIf="isEarlyBird" disabled checked="true" aria-labelledby="example-radio-group-label" class="example-radio-group custom-frame">
        <app-gdo-subscription-item [subscription]="earlybirdplan"></app-gdo-subscription-item>
      </mat-checkbox> -->
    </div>

    <div *ngIf="!type" class="container-buttons">
      <button class="danger-btn" mat-button matStepperPrevious (click)="onCancel()">Cancel</button>
      <button class="primar-btn" [disabled]="'true'" mat-button matStepperPrevious>Previous</button>
      <button mat-button class="primar-btn" [disabled]="
          subsForm.get('packageDetails').invalid ||
          !subsForm.get('packageDetails').controls.availablePackageSelection.value
        " matStepperNext>
        Next
      </button>
    </div>


  </div>
</div>
<div *ngIf="type" class="container-buttons-wv flex-column-wv">
  <button mat-button class="button-with-radius standard-btn {{isAcura ? 'AcuraBtn-disabled' : 'HondaBtn-disabled'}}" [disabled]="
        subsForm.get('packageDetails').invalid ||
        !subsForm.get('packageDetails').controls.availablePackageSelection.value
      " (click)="onPackageSelected()" matStepperNext>
    Next
  </button>
  <!-- <button class="button-wv1" mat-button matStepperPrevious (click)="onCancel()">
    Cancel
  </button> -->
  <!-- <button class="button-with-radius" [disabled]="'true'" mat-button matStepperPrevious>
      Previous
    </button> -->
</div>
